import { useTranslations } from '@vocab/react';
import { TextLink } from 'braid-design-system';
import type { ReactNode, ReactElement } from 'react';

import { useConfig } from 'src/hooks/useConfig';
import { useTracking } from 'src/hooks/useTracking';

import { type AlertTone, AnnouncementBanner } from '../AnnoucementBanner';

import translations from './.vocab';

interface AnalyticsData {
  tone: AlertTone;
  type: string;
  position: string;
  message: string;
  messageCode: string;
}

export const AnnouncementGoToMarket = ({}): ReactElement | null => {
  const { urlResolver } = useConfig();
  const { trackEvent } = useTracking();
  const { t } = useTranslations(translations);

  const STORAGE_TAG_GO_TO_MARKET_ANNOUNCEMENT =
    'jobs-list-announcement-gotomarket-findouthow';
  const ANALYTICS_ALERT_SHOWN_GO_TO_MARKET_ANNOUNCEMENT: AnalyticsData = {
    tone: 'info',
    type: 'banner',
    position: 'content',
    message:
      'From 31 March 2024, you won’t have access to applications and jobs older than 3 years. Download applications you need before then.',
    messageCode: 'go to market warning for old jobs',
  };

  const onViewAnnouncement = () => {
    trackEvent('alert_viewed', {
      alertShown: [ANALYTICS_ALERT_SHOWN_GO_TO_MARKET_ANNOUNCEMENT],
    });
  };

  const onBannerClosed = () => {
    trackEvent('alert_closed', {
      alertShown: [ANALYTICS_ALERT_SHOWN_GO_TO_MARKET_ANNOUNCEMENT],
    });
  };

  const alertContent = t('announcement-go-to-market', {
    Link: (children: ReactNode[]) => (
      <TextLink
        key="gtmdownload"
        href={urlResolver({
          path: '/support/new-terms', // TODO: '/support/new-terms' not in adv-constants
        })}
      >
        {children}
      </TextLink>
    ),
  });

  return (
    <AnnouncementBanner
      alertTone="info"
      alertContent={alertContent}
      onBannerViewed={onViewAnnouncement}
      onBannerClosed={onBannerClosed}
      storageTag={STORAGE_TAG_GO_TO_MARKET_ANNOUNCEMENT}
    />
  );
};
